import Vue from 'vue'
import VueRouter from 'vue-router'

import SiteLayout from '@/views/layout/SiteLayout'

const HomeView = () =>
    import ('@/views/site/HomeView')
const TestView = () =>
    import ('@/views/site/TestView')
const AboutView = () =>
    import ('@/views/site/AboutView')
const BreastpumpComparisonView = () =>
    import ('@/views/site/BreastpumpComparisonView')
const ChooseBreastPumpView = () =>
    import ('@/views/site/ChooseBreastPumpView')
const ChooseBreastPumpResultsView = () =>
    import ('@/views/site/ChooseBreastPumpResultsView')
const DavidScheidtView = () =>
    import ('@/views/site/Team/DavidScheidtView')
const PrescriptionsView = () =>
    import ('@/views/site/PrescriptionsView')
const ResmedMasksView = () =>
    import ('@/views/site/ResmedMasksView')
const LactationresView = () =>
    import ('@/views/site/LactationresView')
const BeststartView = () =>
    import ('@/views/site/resources/BeststartView')
const ClassesView = () =>
    import ('@/views/site/resources/ClassesView')
const FlangesizeView = () =>
    import ('@/views/site/resources/FlangesizeView')
const FlangeComparisonView = () =>
    import ('@/views/site/resources/FlangeComparisonView')
const NationalView = () =>
    import ('@/views/site/resources/NationalView')
const PumpingView = () =>
    import ('@/views/site/resources/PumpingView')
const EcwidView = () =>
    import ('@/views/site/EcwidStorefront')
const LactationednView = () =>
    import ('@/views/site/LactationednView')
const ContactView = () =>
    import ('@/views/site/ContactView')
    const CPAPPrescriptionView = () =>
    import ('@/views/site/CPAPPrescriptionView')
const PrivacyView = () =>
    import ('@/views/site/PrivacyView')
const ShippingDeliveryView = () =>
    import ('@/views/site/ShippingDeliveryView')
const FAQView = () =>
    import ('@/views/site/FAQ.vue')
const TermsView = () =>
    import ('@/views/site/TermsView')
const ReturnView = () =>
    import ('@/views/site/ReturnView')
const ThankYouView = () =>
    import ('@/views/site/ThankYouView')
const LoginView = () =>
    import ('@/views/site/LoginView')
const SignupView = () =>
    import ('@/views/site/SignupView')
const ForgotpasswordView = () =>
    import ('@/views/site/ForgotpasswordView')
const ResetPassword = () =>
    import('@/views/site/ResetPassword')
const RightsResponsibilitiesView = () =>
    import('@/views/site/RightsResponsibilitiesView')
const PrenatalLactationConsultsConsentView = () =>
    import('@/views/site/PrenatalLactationConsultsConsentView')
const CareersView = () =>
    import('@/views/site/CareersView')
const Redirect = () =>
    import ('@/views/site/HomeView')
    //User Views
const UserDashboardView = () =>
    import ('@/views/site/user/common/UserDashboardView')
const ResetPasswordView = () =>
    import ('@/views/site/user/common/ResetPasswordView')
const RedirectUser = () =>
    import ('@/views/site/user/common/UserDashboardView')
const JoinedMeetings = () =>
    import ('@/views/site/user/common/JoinedMeetings')
    // Blog
const BlogView = () =>
    import ('@/views/site/BlogView')
const SkechersView = () =>
    import ('@/views/site/SkechersView')
const SingleBlog = () =>
    import ('@/views/site/SingleBlog')
const CartView = () =>
    import ('@/views/site/CartView')

    // Resmed

    

const Resmedairfitf20View = () =>
    import ('@/views/site/resmed/Resmedairfitf20View')
const AirSense10View = () =>
    import ('@/views/site/resmed/AirSense10View')
const AirFitF20FullFaceMaskForHerView = () =>
    import ('@/views/site/resmed/AirFitF20FullFaceMaskForHerView')
const AirFitF10FullFaceMaskView = () =>
    import ('@/views/site/resmed/AirFitF10FullFaceMaskView')
const AirFitF10FullFaceMaskforHerView = () =>
    import ('@/views/site/resmed/AirFitF10FullFaceMaskforHerView')
const AirFitF30FullFaceMaskView = () =>
    import ('@/views/site/resmed/AirFitF30FullFaceMaskView')
const AirFitF30iFullFaceMaskView = () =>
    import ('@/views/site/resmed/AirFitF30iFullFaceMaskView')
const AirFitN20NasalMaskView = () =>
    import ('@/views/site/resmed/AirFitN20NasalMaskView')
const AirFitN20NasalMaskforHerView = () =>
    import ('@/views/site/resmed/AirFitN20NasalMaskforHerView')
const AirFitP30iNasalMaskView = () =>
    import ('@/views/site/resmed/AirFitP30iNasalMaskView')
const AirFitP10NasalPillowMaskView = () =>
    import ('@/views/site/resmed/AirFitP10NasalPillowMaskView')
const AirTouchF20FullFaceMaskView = () =>
    import ('@/views/site/resmed/AirTouchF20FullFaceMaskView')
const SwiftFxForHerNasalPillowView = () =>
    import ('@/views/site/resmed/SwiftFxForHerNasalPillowView')
const SwiftFXNasalPillowMaskView = () =>
    import ('@/views/site/resmed/SwiftFXNasalPillowMaskView')
const QuattroAirforHerFullFaceMaskView = () =>
    import ('@/views/site/resmed/QuattroAirforHerFullFaceMaskView')
const QuattroFXforHerFullFaceMaskView = () =>
    import ('@/views/site/resmed/QuattroFXforHerFullFaceMaskView')
const MirageFxNasalMaskView = () =>
    import ('@/views/site/resmed/MirageFxNasalMaskView')
const MirageQuattroFullFaceMaskView = () =>
    import ('@/views/site/resmed/MirageQuattroFullFaceMaskView')
const AirFitN30NasalMaskView = () =>
    import ('@/views/site/resmed/AirFitN30NasalMaskView')
const AirFitN30iNasalMaskView = () =>
    import ('@/views/site/resmed/AirFitN30iNasalMaskView')
const ResMedAirFitP30iNasalPillowMaskView = () =>
    import ('@/views/site/resmed/ResMedAirFitP30iNasalPillowMaskView')
const AirtouchN20NasalMaskView = () =>
    import ('@/views/site/resmed/AirtouchN20NasalMaskView')


Vue.use(VueRouter)

var routes;
let userData = JSON.parse(localStorage.getItem('userData'));
var siteRoutesArray = [ //Routes for sites
    { path: '', component: HomeView, name: 'Home', meta: { title: 'Home' } },
    { path: '/about', component: AboutView, name: 'About Us', meta: { title: 'About' } },
    { path: '/test', component: TestView, name: 'Test', meta: { title: 'Test' } },
    { path: '/resmed-masks', component: ResmedMasksView, name: 'Resmed Masks', meta: { title: 'Resmed Masks' } },
    { path: '/compare-breast-pumps', component: BreastpumpComparisonView, name: 'Breast Pumps', meta: { title: 'Breast Pumps' } },
    { path: '/choose', component: ChooseBreastPumpView, name: 'Chose Breast Pumps', meta: { title: 'Help me to choose Breast Pumps' } },
    { path: '/choose-pump-results', component: ChooseBreastPumpResultsView, name: 'ChoosePumpResults', props: true, meta: { title: 'Choose Pump Results'}},
    { path: '/david-scheidt', component: DavidScheidtView, name: 'David Scheidt', meta: { title: 'David Scheidt' } },
    { path: '/prescriptions', component: PrescriptionsView, name: 'Download Prescriptions', meta: { title: 'Download Prescriptions' } },
    { path: '/lactation_res', component: LactationresView, name: 'LactationResources', meta: { title: 'Lactation Resources' } },
    { path: '/lactation_res/best_start', component: BeststartView, name: 'Best Start For Successful Breastfeeding ', meta: { title: 'Best Start For Successful Breastfeeding' } },
    { path: '/lactation_res/classes', component: ClassesView, name: 'Classes, Support Groups', meta: { title: 'Classes, Support Groups' } },
    { path: '/lactation_res/flange_size', component: FlangesizeView, name: 'Flange-shield size document and Flange size reference chart', meta: { title: 'Flange-shield size document and Flange size reference chart' } },
    { path: '/lactation_res/flange-size-comparison', component: FlangeComparisonView, name: 'Flange-shield size Comparison tool', meta: { title: 'Flange-shield size document and Flange size Comparison tools' } },
    { path: '/lactation_res/national', component: NationalView, name: 'Local and National Breastfeeding Resources', meta: { title: 'Local and National Breastfeeding Resources' } },
    { path: '/lactation_res/pumping', component: PumpingView, name: 'Pumping and Back To Work', meta: { title: 'Pumping and Back To Work' } },
    { path: '/shop', component: EcwidView, name: 'Visit our Shop', meta: { title: 'Visit our Shop' } },
    { path: '/lactation_edn', component: LactationednView, name: 'LactationEducation', meta: { title: 'Lactation Education' } },
    { path: '/contact', component: ContactView, name: 'Contact', meta: { title: 'Contact' } },
    { path: '/cpapform', component: CPAPPrescriptionView, name: 'CPAP Prescription ', meta: { title: 'CPAP Prescription' } },
    { path: '/privacy', component: PrivacyView, name: 'Privacy Statement', meta: { title: 'Privacy Statement' } },
    { path: '/shipping-delivery', component: ShippingDeliveryView, name: 'Shipping Delivery', meta: { title: 'Shipping Delivery' } },
    { path: '/faq', component: FAQView, name: 'Frequently Asked Questions', meta: { title: 'FAQ' } },
    { path: '/terms', component: TermsView, name: 'Terms of Use', meta: { title: 'Terms of Use' } },
    { path: '/return', component: ReturnView, name: 'Return Policy', meta: { title: 'Return Policy' } },
    { path: '/rights-responsibilities', component: RightsResponsibilitiesView, name: 'Rights & Responsibilities', meta: { title: 'Rights & Responsibilities'} },
    { path: '/prenatal-lactation-consults-consent', component: PrenatalLactationConsultsConsentView, name: 'Prenatal Lactation Consults', meta: { title: 'Prenatal Lactation Consults'} },
    { path: '/careers', component: CareersView, name: 'Career Opportunities', meta: { title: 'Career Opportunities'} },
    { path: '/site', component: LoginView, name: 'Login', meta: { title: 'Login' } },
    { path: '/skechers', component: SkechersView, name: 'Exclusive CalMed Hawaii and Skechers Deal ', meta: { title: 'Skechers Deal' } },
    { path: '/site/signup', component: SignupView, name: 'Signup', meta: { title: 'Sign up' } },
    { path: '/site/forgot', component: ForgotpasswordView, name: 'Forgot Password', meta: { title: 'Forgot Password' } },
    { path: '/blog', component: BlogView, name: 'Blogs', meta: { title: 'Blogs' } }, 
    { path: '/mahalo', component: ThankYouView, name: 'Thank You page', meta: { title: 'Thank You' } }, 
    { path: '/single_blog/*', component: SingleBlog, name: 'Single Blog', meta: { title: 'Single Blog' } },
    { path: '/cart', component: CartView, name: 'CartView ', meta: { title: 'CartView' } },
    { path: 'password_reset/*', component: ResetPassword, name: 'Reset Password', meta: { title: 'Reset Password' } },

    // Resmed
    { path: '/airsense', component: AirSense10View, name: 'Air Sense 10 Machine ', meta: { title: 'Air Sense 10' } },
    { path: '/resmed-air-fit-f20', component: Resmedairfitf20View, name: 'ResMed AirFit F20 Full Face Mask', meta: { title: 'ResMed AirFit F20 Full Face Mask' } },
    { path: '/airfitf20fullfacemaskforher', component: AirFitF20FullFaceMaskForHerView, name: 'AirFit F20 Full FaceMask ForHer', meta: { title: 'AirFit F20 Full FaceMask ForHer' } },
    { path: '/airfitf10fullfacemask', component: AirFitF10FullFaceMaskView, name: 'AirFit F10 Full Face Mask', meta: { title: 'AirFit F10 Full Face Mask' } },
    { path: '/airfitf10fullfacemaskforher', component: AirFitF10FullFaceMaskforHerView, name: 'AirFit F10 Full Face Mask for Her', meta: { title: 'AirFit F10 Full Face Mask for Her' } },
    { path: '/airfitf30fullfacemask', component: AirFitF30FullFaceMaskView, name: 'AirFit F30 Full Face Mask', meta: { title: 'AirFit F30 Full Face Mask' } },
    { path: '/airfitf30ifullfacemask', component: AirFitF30iFullFaceMaskView, name: 'AirFit F30i Full Face Mask', meta: { title: 'AirFit F30i Full Face Mask' } },
    { path: '/airfitn20nasalmask', component: AirFitN20NasalMaskView, name: 'AirFit N20 Nasal Mask', meta: { title: 'AirFit N20 Nasal Mask' } },
    { path: '/airfitn20nasalmaskforher', component: AirFitN20NasalMaskforHerView, name: 'AirFit N20 Nasal Mask for Her', meta: { title: 'AirFit N20 Nasal Mask for Her' } },
    { path: '/airfitp30inasalmask', component: AirFitP30iNasalMaskView, name: 'AirFit P30i Nasal Mask', meta: { title: 'AirFit P30i Nasal Mask' } },
    { path: '/airfitp10nasalpillowmask', component: AirFitP10NasalPillowMaskView, name: 'AirFit P10 Nasal Pillow Mask', meta: { title: 'AirFit P10 Nasal Pillow Mask' } },
    { path: '/airtouchf20fullfacemask', component: AirTouchF20FullFaceMaskView, name: 'Air Touch F20 Full Face Mask', meta: { title: 'Air Touch F20 Full Face Mask' } },
    { path: '/swiftfxforhernasalpillow', component: SwiftFxForHerNasalPillowView, name: 'Swift Fx For Her Nasal Pillow', meta: { title: 'Swift Fx For Her Nasal Pillow' } },
    { path: '/swiftfxnasalpillowmask', component: SwiftFXNasalPillowMaskView, name: 'Swift FX Nasal Pillow Mask', meta: { title: 'Swift FX Nasal Pillow Mask' } },
    { path: '/quattroairforherfullfacemask', component: QuattroAirforHerFullFaceMaskView, name: 'Quattro Air for Her Full Face Mask', meta: { title: 'Quattro Air for Her Full Face Mask' } },
    { path: '/quattrofxforherfullfacemask', component: QuattroFXforHerFullFaceMaskView, name: 'Quattro FX for Her Full Face Mask', meta: { title: 'Quattro FX for Her Full Face Mask' } },
    { path: '/miragefxnasalmask', component: MirageFxNasalMaskView, name: 'Mirage Fx Nasal Mask', meta: { title: 'Mirage Fx Nasal Mask' } },
    { path: '/miragequattrofullfacemask', component: MirageQuattroFullFaceMaskView, name: 'Mirage Quattro Full Face Mask', meta: { title: 'Mirage Quattro Full Face Mask' } },
    { path: '/airfitn30nasalmask', component: AirFitN30NasalMaskView, name: 'AirFit N30 Nasal Mask', meta: { title: 'AirFit N30 Nasal Mask ' } },
    { path: '/airfitn30inasalmask', component: AirFitN30iNasalMaskView, name: 'AirFit N30i Nasal Mask', meta: { title: 'AirFit N30i Nasal Mask' } },
    { path: '/resmedairfitp30inasalpillowmask', component: ResMedAirFitP30iNasalPillowMaskView, name: 'ResMed AirFit P30i Nasal Pillow Mask', meta: { title: 'ResMed AirFit P30i Nasal Pillow Mask' } },
    { path: '/airtouchn20nasalmask', component: AirtouchN20NasalMaskView, name: 'Airtouch N20 Nasal Mask', meta: { title: 'Airtouch N20 Nasal Mask ' } },
];
if (userData && userData.user.role == 'User') { 
    siteRoutesArray.push({ path: '/user/dashboard', component: UserDashboardView, name: 'Dashboard', meta: { title: 'User Dashboard' } }, { path: '/user/reset_password', component: ResetPasswordView, name: 'Reset Password', meta: { title: 'Reset Password' } }, { path: '/user/joned_meetings', component: JoinedMeetings, name: 'Joined Meetings', meta: { title: 'Online Classes' } }, { path: '*', component: RedirectUser, name: 'RedirectUser', meta: { title: 'Redirect' } }, );
} else {
    siteRoutesArray.push({ path: '*', component: Redirect, meta: { title: 'Home' } }, );
}
routes = [{
    path: '/',
    component: SiteLayout,
    children: siteRoutesArray
}, ]


const router = new VueRouter({
    mode: 'history',
    base: process.env.PUBLIC_PATH,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 };
        }
    }
})


siteRoutesArray.push({
    path: '/bp-cheat-sheet',
    beforeEnter(to, from, next) {
      window.location.href = '/pdf/BP-Cheat-Sheet-CalMed-Hawaii.pdf'
    },
    name: 'BPCheatSheet',
    meta: { title: 'BP Cheat Sheet' }
});

siteRoutesArray.push({
    path: '/abn',
    beforeEnter(to, from, next) {
      window.location.href = '/pdf/ABN.pdf'
    },
    name: 'ABN',
    meta: { title: 'ABN' }
});

  

export default router